module.exports = __webpack_public_path__ + "static/media/image-7.242c0b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-7.png
// module id = 435
// module chunks = 0